/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_Grid from 'canvas/base/dev/child/grid/B_Grid';
import B_GridChild from 'canvas/base/dev/child/grid/B_GridChild';
import B_Sprite from 'canvas/base/dev/child/sprite/B_Sprite';
import B_Define from 'canvas/base/dev/util/B_Define';
import {isDist} from 'canvas/base/dev/util/B_Config';

let mix = (superclass) => new MixinBuilder(superclass);

const B_ToolJoyPad = (function () {

	const $ = {
		_strTarget: null,
		_objTarget: null,
		_zoneOuter: null,
		_btnLeft: null,
		_btnRight: null,
		_btnTop: null,
		_btnDown: null,
		_btnCenter: null
	};

	const ARR_DIRECTION = [
		{
			id: B_Define.JOYPAD_BTN_LEFT_RES,
			action: 'moveLeft',
			x: 1,
			y: 2
		},
		{
			id: B_Define.JOYPAD_BTN_TOP_RES,
			action: 'moveTop',
			x: 2,
			y: 1
		},
		{
			id: B_Define.JOYPAD_BTN_RIGHT_RES,
			action: 'moveRight',
			x: 3,
			y: 2
		},
		{
			id: B_Define.JOYPAD_BTN_DOWN_RES,
			action: 'moveDown',
			x: 2,
			y: 2
		}
	];

	class B_ToolJoyPad extends B_Grid {

		constructor(obj) {
			super(obj);

			// [S] target
			if (obj.target) this._strTarget = obj.target;

			// [S] listener

			if(isDist())
				this._useKey = false; // 배포버전에서는 사용하지 않음
			else
				this._useKey = true;  // 테스트버전에서는 사용함
		}

		// [V] protected

		// @DES :: _objTarget {obj}
		get _objTarget() { return this.CODMOS.WORLD[this._strTarget]; }

		// [V] public

		// @DES :: USE_KEY {bool} - 키를 사용할 것인지 여부
		get USE_KEY() { return this._useKey; }
		set USE_KEY(uk) { this._useKey = uk; }

		// [F]

		/**
		 * @DES :: init shape & image
		 * @IP1 :: gridId {str}
		 * @O.P :: null
		 * @S.E :: 특이사항없음
		 */
		_initJoyPad(gridId) {

			// [S]
			const classImage = class extends mix(B_Real).with(B_Sprite, B_GridChild) { constructor(obj) { super(obj); } };

			ARR_DIRECTION.forEach((v) => {
				this[v.id] = new classImage({
					parent: gridId,
					cm: this.CODMOS,
					id: v.id,
					res: v.id,
					x: v.x,
					y: v.y,
					size: B_Define.JOYPAD_ICON_SIZE,
				});
				this[v.id]._setArea();
				this[v.id]._setPoint();
				this._container.addChild(this[v.id]._container);
			});
		}

		/**
		 * @DES :: 이벤트리스너처리
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E :: this.target이 만드시 있어야합니다.
		 */
		_addClickListener() {
			ARR_DIRECTION.forEach((v) => {
				this[v.id]._container.on('click', () => {
					// [#] 타켓이 정확히 있는가?
					if (typeof this._objTarget == 'undefined') {
						B_Util.print(B_Define.MESSAGE['NO_TARGET_OBJECT']);
						return;
					}
					else this._objTarget[v.action]();
				});
			});
		}

		/**
		 * @DES :: 키이벤트리스너처리
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E :: USE_KEY의 여부에 따라 key 이벤트를 사용할지 하지 않을지 결정합니다.
		 */
		_addKeyDownListener() {
			window.addEventListener("keydown", (e) => {

				// [#] KEY를 사용할 것인가?
				if(this.USE_KEY) {

					// [#] 타켓이 정확히 있는가?
					if (typeof this._objTarget == 'undefined') {
						B_Util.print(B_Define.MESSAGE['NO_TARGET_OBJECT']);
						return;
					}
					else {
						switch (e.keyCode) {
							case 37: // LEFT
								this._objTarget[ARR_DIRECTION[0].action]();
								break;
							case 38: // UP
								this._objTarget[ARR_DIRECTION[1].action]();
								break;
							case 39: // RIGHT
								this._objTarget[ARR_DIRECTION[2].action]();
								break;
							case 40: // DOWN
								this._objTarget[ARR_DIRECTION[3].action]();
								break;
						}
					}
				}
			});
		}

	}

	return B_ToolJoyPad;
}());

export default B_ToolJoyPad;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_ToolJoyPad.js